/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* gebruiker_filter.ts
* 21-10-2025 - Jelmer Jellema - Spin in het Web B.V.
*
* Gegenereerd met Junie (AI), 21-10-2025
*
* Model voor het opslaan van front-end filters per gebruiker. Dit model bevat geen relaties.
*/

import {Basemodel, ModelField} from './basemodel';

/**
 * Klasse GebruikerFilter
 * Vertegenwoordigt opgeslagen front-end filters. Bevat uitsluitend de velddefinities.
 */
export class GebruikerFilter extends Basemodel {
  static table = 'gebruiker_filter';
  static defaultOrder = ['naam'];

  // velden zoals gedefinieerd in de database-tabel gebruiker_filter
  @ModelField() override id: number = null;
  @ModelField() gebruiker_id: number; // FK naar gebruiker.id (geen relationele mapping in dit model)
  @ModelField() werkmaatschappij_id: number; // FK naar werkmaatschappij.id (geen relationiele mapping in dit model)
  @ModelField() naam: string = '';
  @ModelField() filter: string = '';// JSON-string met de filterconfiguratie
  @ModelField() publiek: boolean = false; // zichtbaar voor anderen binnen de organisatie


  /**
   * Laadt op instance-niveau, indien nodig, de JSON van het filter in dit record.
   * Wanneer `filter` reeds aanwezig is, wordt niets opgehaald.
   * Er wordt alleen het minimale setje velden (`id`, `filter`) opgehaald en de cache blijft intact.
   */
  async haalFilter(): Promise<void> {
    if (this.filter && this.filter.toString().length) {
      return; // al beschikbaar
    }
    await this.resetFromDB(undefined, [[GebruikerFilter, { attributes: ['id', 'filter'] }]], false);
  }
}
